import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';
import { WidgetDynamicBaseComponent } from '../../widgetDynamicBase';

@Component({
  selector: 'sales-approach-valuation-widget',
  templateUrl: './sales-approach-valuation-widget.component.html',
  styleUrls: ['./sales-approach-valuation-widget.component.scss', '../../common/css/general.scss']
})
export class SalesApproachValuationWidgetComponent extends WidgetDynamicBaseComponent implements OnInit  {
  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'salesApproachValuation', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("salesApproachValuation", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('salesApproachValuation');

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('salesApproachValuation', this.getReport());
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {
    this.setDirtyFlag(false);
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  public getMinimumRowIndex(): number {
    return 1;
  }

  public getMaximumRowIndex(): number {
    return 34;
  }

  /**
   * Based on the amount of columns in the data, each widget can request to be put on a H page if it's alone on a V page
   * @returns true if it could need more columns
   */
  public moreColumnsRequestedIfOnPortraitPage(): boolean {
    return false;//This widget always fits
  }

}
